import React from 'react';

export default function PageHero({ eyebrow, title, subtitle, image }) {
  return (
    <section className="relative overflow-hidden min-h-[280px] sm:min-h-[340px] flex items-center">
      <img src={image} alt="" className="absolute inset-0 w-full h-full object-cover" />
      <div className="absolute inset-0 marketing-hero-overlay" />
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 w-full">
        {eyebrow && (
          <p className="text-[#99E1D9] font-semibold tracking-wide uppercase text-xs mb-3">{eyebrow}</p>
        )}
        <h1 className="text-3xl sm:text-5xl font-extrabold text-white max-w-3xl leading-tight">{title}</h1>
        {subtitle && <p className="mt-4 text-white/85 text-lg max-w-2xl">{subtitle}</p>}
      </div>
    </section>
  );
}
